import React from "react";
import { HiOutlineArrowRight } from "react-icons/hi";
import { classNames } from "Utils/utils";

const SuggestedPrompts = ({
  prompts = [],
  moduleId = "",
  onSelect,
  disabled = false,
}) => {
  if (!prompts.length) {
    return (
      <p className="rounded-2xl border border-dashed border-slate-200/80 bg-slate-50/60 px-4 py-6 text-center text-xs text-slate-500">
        No prompts available for this module yet.
      </p>
    );
  }

  return (
    <div
      className="copilot-suggested-prompts"
      role="tabpanel"
      aria-label={`${moduleId} prompts`}
    >
      {prompts.map((item) => (
        <button
          key={item.id}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(item.prompt)}
          className={classNames(
            "copilot-prompt-action copilot-suggested-prompt group",
            "disabled:cursor-not-allowed disabled:opacity-60"
          )}
        >
          <span className="copilot-suggested-prompt__body">
            <span className="copilot-suggested-prompt__title">{item.title}</span>
            <span className="copilot-suggested-prompt__text">{item.prompt}</span>
          </span>
          <span className="copilot-suggested-prompt__arrow" aria-hidden>
            <HiOutlineArrowRight />
          </span>
        </button>
      ))}
    </div>
  );
};

export default SuggestedPrompts;
